import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  addItem,
  removeItem,
  clearCart,
  getProductList,
  setDonationTab,
  addProduct,
  clearDonationCart,
} from "./slice";
import { updateDonation } from "../DonationView/slice";
import {
  Grid,
  Tab,
  Paper,
  Avatar,
  Typography,
  ButtonGroup,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Address from "./Address";
import { Box } from "@mui/system";
import i18next from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";

import Products from "./Products";

import { useNavigate } from "react-router-dom";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Cart from "./Cart";
import Badge from "@mui/material/Badge";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { setSnackbarOpen } from "../AdminView/adminSlice";
import Snackbar from "../../components/Snackbar";
import { units } from "../../common/enum";

const Donation = () => {
  const theme = useTheme();
  const matchesDown = useMediaQuery(theme.breakpoints.down("md"));
  const {
    translate,
    donationCart: {
      products: items,
      donationTab,
      donationId,
      donationType,
      updateDonationDetail,
    },
    adminDashboard: { snackBarOpen, snackBarMessage, snackBarSeverity },
  } = useSelector((state) => state);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const onHandleClick = React.useCallback(() => setOpen(true), []);

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  React.useEffect(() => {
    const loadProducts = async () => {
      dispatch(getProductList());
    };
    loadProducts();
  }, []);

  const dispatch = useDispatch();

  const handleTabChange = (event, newValue) => {
    dispatch(setDonationTab(newValue));
  };

  const onClose = React.useCallback(() => {
    dispatch(setSnackbarOpen(false));
  }, [dispatch]);

  const cancelHandle = () => {
    navigate("/dashboard");
    for (const element of items) {
      const payload = {
        donationId: donationId,
        productId: element.productId,
        totalProductQuantity: 0,
        unit: units[element.unitIndex],
      };
      dispatch(addProduct(payload));
    }
    dispatch(clearCart());
    dispatch(setDonationTab("product"));
  };

  return (
    <>
      <Grid container height={"100vh"}>
        <Grid
          item
          xs={12}
          sm={12}
          md={9}
          lg={donationType === "donation" ? 9 : 12}
          xl={donationType === "donation" ? 9 : 12}
          justifyContent="center"
        >
          <TabContext
            value={donationType === "donation" ? donationTab : "collection"}
          >
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                padding: "20px 92px 0px 40px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <TabList
                className={"mmmmmmm"}
                aria-label="lab API tabs example"
                indicatorColor="none"
                onChange={handleTabChange}
              >
                {donationType === "donation" && (
                  <Tab label={"01. " + t("product")} value={"product"} />
                )}
                <Tab
                
                  label={
                    donationType === "donation"
                      ? "02. " + t("collection")
                      : "01. " + t("collection")
                  }
                  value={"collection"}
                />
              </TabList>
              <Button
             
                color="error"
                sx={{ background: "#FFEEEE", color: "#FF0000", mb: 1,borderRadius:"4px" , 
                  "@media (max-width:900px)": {
                  position: 'absolute', right: "42px"
                  },
                }}
                onClick={cancelHandle}
              >
                Cancelar
              </Button>
              {matchesDown && (
                <Button 
                  sx={{ minWidth: "0px" ,  
                      "@media (max-width:900px)": {
                        position: 'absolute', right: 0
                    },
                  }} 
                  onClick={onHandleClick}>
                  <Badge badgeContent={items.length} color="secondary">
                    <ShoppingCartIcon />
                  </Badge>
                </Button>
              )}
            </Box>
            <TabPanel value={"product"}>
              <Products t={t} />
            </TabPanel>
            <TabPanel value={"collection"}>
              <Address t={t} />
            </TabPanel>
          </TabContext>
        </Grid>
        {donationType === "donation" && (
          <Grid item xs={12} lg={3}>
            <Cart t={t} open={open} setOpen={setOpen} />
          </Grid>
        )}
      </Grid>
      <Snackbar
        open={snackBarOpen}
        severity={snackBarSeverity}
        onClose={onClose}
        message={snackBarMessage}
        t={t}
      />
    </>
  );
};

export default Donation;
